(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OpenSpaceController', OpenSpaceController);

    OpenSpaceController.$inject = ['$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', 'AreaCalculationService', '$localStorage'];

    function OpenSpaceController($log, AreaService, $rootScope, $translate, CartFactory, $state, AreaCalculationService, $localStorage) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];
        vm.priceTable = [];
        vm.powerunit;


        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.openSpace = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionType: 'Open_Space',
            cartPositionId: null
        };

        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.showPrices = showPrices;
        vm.goBack = goBack;

        function goBack() {
            $state.go('area');
        }

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateBookingOptions(vm.bookingoptions);
            translateComboBoxValues(vm.prices.prices);

        });


        function translateBookingOptions(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Open_Space').then(successPrices, error);
            AreaService.loadLabels('Open_Space').then(successLabels, error);
            AreaService.loadBookingOptions('Open_Space').then(successBookingOptions, error);
            AreaService.loadCartLabels('Open_Space').then(successCartLabels, error)
        }

        function successPrices(response) {
            $log.debug("OpenSpaceController | Fetching prices ", response.data);
            vm.prices = response.data
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("OpenSpaceController | Fetching labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('OpenSpaceController | fetching area translation', response.data);
            vm.openSpace.cartPositionLabel = response.data;
        }

        function successBookingOptions(response) {
            $log.debug("OpenSpaceController | Fetching booking options", response.data);
            vm.bookingoptions = response.data;
            translateBookingOptions(vm.bookingoptions);
        }


        function error(response) {
            $log.debug('OpenSpaceController | ERROR:', response);
        }

        function pageLoaded() {

            // TODO
            return true;
            if (vm.bookingoptions) {
                return true;
            }
            return false;
        }

        function bookArea() {
            calculateAreaPrice();
            var bookingOptionTitle = vm.openSpace.bookingoption ? vm.openSpace.bookingoption.title : null;

            var item = {
                type: 'Area',
                areaType: 'Open_Space',
                cartPositionPrice: vm.openSpace.cartPositionPrice,
                cartPositionParent: null,
                cartPositionLabel: vm.openSpace.cartPositionLabel,
                cartPositionId: null,
                cartPositionPowerUnit: vm.powerunit,
                cartPositionBookingOptionTitle: bookingOptionTitle,
                bookingOption: vm.openSpace.bookingoption.id,
                fields: {
                    suggestions: vm.openSpace.suggestions,
                    weExhibit: vm.openSpace.vehicleDescription,
                    vehicleDescription: vm.openSpace.vehicleDescription,
                    additionalSquareMeters: vm.openSpace.additionalSquareMeters,
                    powerAmount: vm.openSpace.powerAmount
                },
                id: null
            };

            CartFactory.addItem(item);

            $localStorage.showSuccessAlert = true;
            $log.debug('OpenSpaceController | saving area', item);
            $state.go('area');
        }

        function resetPackage() {
            vm.openSpace.package = null;
        }

        function showPrices() {
            vm.priceTable = [];

            angular.forEach(vm.bookingoptions, function (bookingoption) {
                if (vm.openSpace.bookingoption == bookingoption) {
                    vm.powerunit = bookingoption.powerUnit;

                    angular.forEach(bookingoption.price.prices, function (price) {
                        vm.priceTable.push({
                            name: price.title[vm.lang],
                            smIncluded: price.smIncluded,
                            price: price.price
                        });
                    });
                }
            });
        }

        function calculateAreaPrice() {
            $log.debug('OpenSpaceController | calculating price with power', vm.openSpace.powerAmount);
            vm.openSpace.cartPositionPrice = AreaCalculationService.calculateAreaPrice(vm.openSpace.bookingoption.price, vm.openSpace.powerAmount);
            $log.debug('OpenSpaceController | area price ', vm.openSpace.cartPositionPrice);

            if (vm.openSpace.additionalSquareMeters) {
                // Fix for additional squaremeters disposal fee
                var additionalSquaremeters = vm.openSpace.additionalSquareMeters;
                $log.debug('OpenSpaceController |  additionalsquaremeters', additionalSquaremeters);

                var disposalPrice = additionalSquaremeters * vm.prices.disposalFee;
                $log.debug('OpenSpaceController | calculating disposalprice ', disposalPrice);

                // Calculate fix price for additional squaremeters:
                if (vm.prices.prices[0].price) {
                    $log.debug('OpenSpaceController | calculating price for additional squaremeters', (vm.prices.prices[0].price * vm.openSpace.additionalSquareMeters));
                    vm.openSpace.cartPositionPrice += vm.openSpace.additionalSquareMeters * vm.prices.prices[0].price;
                }
                vm.openSpace.cartPositionPrice += disposalPrice;
            }

            vm.openSpace.cartPositionParent = null;
        }

        return vm;
    }
})();
